exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-slider-wrapper[data-v-3a989f20]{width:100%;padding-bottom:10px}.v-carousel__controls[data-v-3a989f20]{display:none!important}.embed-slider-wrapper .v-window-item[data-v-3a989f20]{padding-left:50px;padding-right:50px}", ""]);

// exports
